<template>
  <div>
    <div class="pdf-container">
        <pdf :src="pdfUrl"/>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
  name: "vuepdf",
  components: { pdf },
  data() {
    return {
      // 此处为示例pdf地址
      pdfUrl: "http://image.cache.timepack.cn/nodejs.pdf"
    };
  },

  methods: {},

  created() {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/vuepdf.vue